export async function resetNodeStyle(nodes) {
    await this.execute(
        () => this.actions.resetNodeStyle(nodes)
    )
}
